import React from 'react';

import useBooleanState from '~/hooks/useBooleanState';

import SearchHistory from './SearchHistory';
import SearchInputWrapper from './SearchInputWrapper';

import styles from './SearchWithHistory.module.scss';

const SearchWithHistory: React.FC = () => {
  const [isInputFocused, changeInputFocused] = useBooleanState();
  return (
    <div className={styles.wrapper}>
      <SearchInputWrapper changeInputFocused={changeInputFocused} />
      <SearchHistory isOpen={isInputFocused} />
    </div>
  );
};

export default SearchWithHistory;
